// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"2bf47e3d","629":"2497932e","863":"f4b92d98","976":"a414e545"}[chunkId] + ".chunk.js";
};